<div class="row">
  <div class="col-12 mb-3">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4>{{ 'agents.intentionsForm.title' | translate }}</h4>
        <small>{{ 'agents.intentionsForm.subtitle' | translate }}</small>
      </div>
      <button
        type="button"
        class="btn btn-primary d-flex align-items-center"
        (click)="openModal()"
      >
        <i class="mdi mdi-plus me-2"></i>
        {{ 'agents.intentionsForm.addButton' | translate }}
      </button>
    </div>
  </div>
</div>
<div class="card">
  @if (loadingContent) {
  <content-loading-list></content-loading-list>
  }
  @if(intentions?.length === 0) {
  <empty-records-legacy-component></empty-records-legacy-component>
  }
  <div class="card-body table-responsive">
        <table class="table table-hover table-centered mb-0">
          <thead>
            <tr>
              <th class="text-primary-emphasis">{{ 'agents.intentionsForm.descriptionHeader' | translate }}</th>
              <th><span class="sr-only"></span></th>
            </tr>
          </thead>
          <tbody>
            @for(int of intentions; track $index) {
              <tr>
                <td>{{ int.description }}</td>
                <td>
                  <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-dropdown-list" [matMenuTriggerFor]="menu">
                      <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                    </button>

                    <mat-menu #menu="matMenu">
                      <button mat-menu-item tabindex="0" (click)="openModal(int)">{{ 'agents.intentionsForm.edit' | translate }}</button>
                      <button mat-menu-item tabindex="0" (click)="delete(int.id)">{{ 'agents.intentionsForm.delete' | translate }}</button>
                    </mat-menu>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
  </div>
</div>